import { useEffect } from "react";
import { getUpdatedEquipmentAnomalySummary } from "../utils/utilities";
import { EquipmentAnomalySummaryItem, NewAnomalyItem } from "../utils/models";
import _ from "lodash";

interface Props {
    anomalyItems: NewAnomalyItem[];
    anomalySummary: EquipmentAnomalySummaryItem;
    isNewFormat: boolean;
    onSaveAnomalySummary: (newAnomalySummary: EquipmentAnomalySummaryItem) => void;
}

const useEquipmentAnomalySummaryUpdate = ({ isNewFormat, anomalyItems, anomalySummary, onSaveAnomalySummary }: Props) => {
    useEffect(() => {
		function updateAnomalySummary() {
			const newAnomalySummary = getUpdatedEquipmentAnomalySummary(isNewFormat, anomalySummary, anomalyItems);
			if (!newAnomalySummary || _.isEqual(anomalySummary, newAnomalySummary)) return;

			onSaveAnomalySummary(newAnomalySummary);
		}

		updateAnomalySummary();

	    // eslint-disable-next-line
	}, [isNewFormat, anomalySummary, anomalyItems]);
    
    return null;
};
 
export default useEquipmentAnomalySummaryUpdate;